import React from 'react';
import { useIntl } from 'react-intl';
// Core
import { Grid, Box } from '@mui/material';
// Components
import RadioGroup, { RadioCheck } from 'Components/RadioGroup';
// Utilities
import { getFeatureDisplayCode } from '../modules/hierarchicalFeatures';
import { selectSingleSubModule } from '../modules/singleSelectionModules';

/**
 * Local permissions of a module that accepts exactly ONE selected subModule
 * (e.g. `coachsso`). Rendered as a single radio group across all groupNames so
 * picking a subModule unchecks the previous one and the selection can never be empty.
 */
const SingleSubModule = ({ localPermissions, globalPermission, onChange }) => {
  const { messages } = useIntl();

  const allSubModules = localPermissions.flatMap((lp) => lp.subModules);
  const selected = allSubModules.find((subModule) => subModule.checked);
  const value = selected ? getFeatureDisplayCode(selected.code) : '';
  const disabled = !globalPermission?.checked;

  const handleChange = (code) => {
    if (disabled) return;
    onChange(
      localPermissions.map((section) => ({
        ...section,
        subModules: selectSingleSubModule(section.subModules, code),
      }))
    );
  };

  return (
    <Grid item sm={12}>
      <label className="title-permission">{messages['role_localAccess']}</label>
      <RadioGroup id={`permission-${globalPermission.code}-single`} value={value} onChange={handleChange}>
        {localPermissions.map((item, indexSection) => (
          <Grid key={`section-local-permissions-${indexSection}`} item sm={12}>
            <Grid item sm={12}>
              <Box mt={2} mb={1}>
                <label>{messages[`role_${item.groupName}`] ?? item.groupName}</label>
              </Box>
            </Grid>
            {item.subModules.map((subModule, indexSubModule) => {
              const code = getFeatureDisplayCode(subModule.code);
              return (
                <Grid key={`local-permissions-${indexSubModule}`} item sm={12}>
                  <RadioCheck
                    id={`permission-${subModule.code}`}
                    value={code}
                    size="small"
                    label={messages[`role_${globalPermission.code}_${code}`] || subModule.name}
                    disabled={disabled}
                  />
                </Grid>
              );
            })}
          </Grid>
        ))}
      </RadioGroup>
    </Grid>
  );
};

export default SingleSubModule;
